// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/contracts/contracts.proto (package aurora.core.apiengine.contractsv1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { PbInstrument, PbRateDetails } from "../../../../common/protos/types_pb";
import { file_common_protos_types } from "../../../../common/protos/types_pb";
import type { ContractStatus, RoundingRule } from "../../../../consts/loanconsts_pb";
import { file_consts_loanconsts } from "../../../../consts/loanconsts_pb";
import type { ContractRequestStatus } from "../../../../consts/loanrequestconsts_pb";
import { file_consts_loanrequestconsts } from "../../../../consts/loanrequestconsts_pb";
import type { Side } from "../../../../consts/commonconsts_pb";
import { file_consts_commonconsts } from "../../../../consts/commonconsts_pb";
import type { ContractRecallStatus } from "../../../../consts/loanrecallconsts_pb";
import { file_consts_loanrecallconsts } from "../../../../consts/loanrecallconsts_pb";
import type { ContractBuyInStatus } from "../../../../consts/loanbuyinconsts_pb";
import { file_consts_loanbuyinconsts } from "../../../../consts/loanbuyinconsts_pb";
import type { SettlementType } from "../../../../consts/settlementconsts_pb";
import { file_consts_settlementconsts } from "../../../../consts/settlementconsts_pb";
import type { BigintFilter, DecimalFilter, SortOrder } from "../../../../consts/queryconsts_pb";
import { file_consts_queryconsts } from "../../../../consts/queryconsts_pb";
import type { ContractHistoryEventInitiatorKind, ContractHistoryEventType, ContractHistorySortableField } from "../../../../consts/loanhistoryconsts_pb";
import { file_consts_loanhistoryconsts } from "../../../../consts/loanhistoryconsts_pb";
import type { ContractReturnStatus } from "../../../../consts/loanreturnconsts_pb";
import { file_consts_loanreturnconsts } from "../../../../consts/loanreturnconsts_pb";
import type { ContractRateModificationStatus } from "../../../../consts/ratemodificationconsts_pb";
import { file_consts_ratemodificationconsts } from "../../../../consts/ratemodificationconsts_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/contracts/contracts.proto.
 */
export const file_modules_apiengine_services_contracts_contracts: GenFile = /*@__PURE__*/
  fileDesc("CjRtb2R1bGVzL2FwaWVuZ2luZS9zZXJ2aWNlcy9jb250cmFjdHMvY29udHJhY3RzLnByb3RvEiFhdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEiKQoSR2V0Q29udHJhY3RSZXF1ZXN0EhMKC2NvbnRyYWN0X2lkGAEgASgJIlQKE0dldENvbnRyYWN0UmVzcG9uc2USPQoIY29udHJhY3QYASABKAsyKy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ29udHJhY3QiSwoVQ2FuY2VsQ29udHJhY3RSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIKCgJpZBgCIAEoCUINCgtfcmVxdWVzdF9pZCIkChZDYW5jZWxDb250cmFjdFJlc3BvbnNlEgoKAmlkGAEgASgJIukBCgZSZWNhbGwSCgoCaWQYASABKAkSEwoLY29udHJhY3RfaWQYAiABKAkSTgoNcmVjYWxsX3N0YXR1cxgDIAEoDjI3LmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdHJlY2FsbC5Db250cmFjdFJlY2FsbFN0YXR1cxIQCghxdWFudGl0eRgEIAEoAxIjChZhbGxvd2VkX2V4ZWN1dGlvbl9kYXRlGAUgASgJSACIAQESHAoUaW5pdGlhdG9yX2NvbXBhbnlfaWQYBiABKAlCGQoXX2FsbG93ZWRfZXhlY3V0aW9uX2RhdGUiZgoVUmVjYWxsQ29udHJhY3RSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARITCgtjb250cmFjdF9pZBgCIAEoCRIQCghxdWFudGl0eRgDIAEoA0INCgtfcmVxdWVzdF9pZCJTChZSZWNhbGxDb250cmFjdFJlc3BvbnNlEjkKBnJlY2FsbBgBIAEoCzIpLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5SZWNhbGwi1gMKFExpc3RDb250cmFjdHNSZXF1ZXN0ElgKDXN0YXR1c19maWx0ZXIYASABKA4yPC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuTGlzdENvbnRyYWN0c1N0YXR1c0ZpbHRlckgAiAEBEg8KAmlkGAIgASgJSAGIAQESGAoLY2xvc2VkX2RhdGUYBCABKAlIAogBARIyCgRzaWRlGAUgASgOMh8uYXVyb3JhLmNvcmUuY29uc3RzLmNvbW1vbi5TaWRlSAOIAQESGAoQY291bnRlcnBhcnR5X2lkcxgGIAMoCRIXCgppbnN0cnVtZW50GAcgASgJSASIAQESHQoQY3JlYXRlZF9hdF9zdGFydBgIIAEoCUgFiAEBEhsKDmNyZWF0ZWRfYXRfZW5kGAkgASgJSAaIAQESEwoLcGFnZV9udW1iZXIYCiABKAUSEgoKcGFnZV9saW1pdBgLIAEoBUIQCg5fc3RhdHVzX2ZpbHRlckIFCgNfaWRCDgoMX2Nsb3NlZF9kYXRlQgcKBV9zaWRlQg0KC19pbnN0cnVtZW50QhMKEV9jcmVhdGVkX2F0X3N0YXJ0QhEKD19jcmVhdGVkX2F0X2VuZEoECAMQBCJsChVMaXN0Q29udHJhY3RzUmVzcG9uc2USPgoJY29udHJhY3RzGAEgAygLMisuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNvbnRyYWN0EhMKC3RvdGFsX2NvdW50GAIgASgDIswGCghDb250cmFjdBIKCgJpZBgBIAEoCRJGCg9zZXR0bGVtZW50X3R5cGUYAiABKA4yLS5hdXJvcmEuY29yZS5jb25zdHMuc2V0dGxlbWVudC5TZXR0bGVtZW50VHlwZRIVCg1zZXR0bGVtZW50X2lkGAMgASgJEjsKCmluc3RydW1lbnQYBCABKAsyJy5hdXJvcmEuY29yZS5jb21tb24ucHJvdG9zLlBiSW5zdHJ1bWVudBItCgRzaWRlGAUgASgOMh8uYXVyb3JhLmNvcmUuY29uc3RzLmNvbW1vbi5TaWRlEhcKD2NvdW50ZXJwYXJ0eV9pZBgGIAEoCRIyCgZzdGF0dXMYByABKA4yIi5hdXJvcmEuY29yZS5jb25zdHMuQ29udHJhY3RTdGF0dXMSEAoIcXVhbnRpdHkYCCABKAMSPgoMcmF0ZV9kZXRhaWxzGAkgASgLMiguYXVyb3JhLmNvcmUuY29tbW9uLnByb3Rvcy5QYlJhdGVEZXRhaWxzEhcKD2NvbGxhdGVyYWxfcmF0ZRgKIAEoCRI3Cg1yb3VuZGluZ19ydWxlGAsgASgOMiAuYXVyb3JhLmNvcmUuY29uc3RzLlJvdW5kaW5nUnVsZRIbChNpbnRlcmVzdF9kdWVfYW1vdW50GAwgASgJEhQKDG1hcmtldF92YWx1ZRgNIAEoCRIWCg5jb250cmFjdF92YWx1ZRgOIAEoCRIhChljb250cmFjdF92YWx1ZV9hZGp1c3RtZW50GA8gASgJEhIKCmNyZWF0ZWRfYXQYECABKAkSFwoPc2V0dGxlbWVudF9kYXRlGBEgASgJEhkKEXJlY2FsbGVkX3F1YW50aXR5GBIgASgDEhkKEXJldHVybmVkX3F1YW50aXR5GBMgASgDEhkKDGFncmVlbWVudF9pZBgUIAEoCUgAiAEBEhIKCnVuaXRfcHJpY2UYFSABKAkSFQoNbGFzdF9xdWFudGl0eRgWIAEoAxIZChFsYXN0X21hcmtldF92YWx1ZRgXIAEoCRIbChNsYXN0X2NvbnRyYWN0X3ZhbHVlGBggASgJEhgKEGNvbGxhdGVyYWxfcHJpY2UYGSABKAlCDwoNX2FncmVlbWVudF9pZCJmChtDYW5jZWxSZWNhbGxDb250cmFjdFJlcXVlc3QSFwoKcmVxdWVzdF9pZBgBIAEoCUgAiAEBEgoKAmlkGAIgASgJEhMKC2NvbnRyYWN0X2lkGAMgASgJQg0KC19yZXF1ZXN0X2lkIlkKHENhbmNlbFJlY2FsbENvbnRyYWN0UmVzcG9uc2USOQoGcmVjYWxsGAEgASgLMikuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlJlY2FsbCJNChdDYW5jZWxBbGxSZWNhbGxzUmVxdWVzdBIXCgpyZXF1ZXN0X2lkGAEgASgJSACIAQESCgoCaWQYAiABKAlCDQoLX3JlcXVlc3RfaWQiJgoYQ2FuY2VsQWxsUmVjYWxsc1Jlc3BvbnNlEgoKAmlkGAEgASgJInkKFEJ1eUluQ29udHJhY3RSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIKCgJpZBgCIAEoCRIQCghxdWFudGl0eRgDIAEoAxIbChNhdmdfcHJpY2VfcGVyX3NoYXJlGAQgASgJQg0KC19yZXF1ZXN0X2lkIlAKFUJ1eUluQ29udHJhY3RSZXNwb25zZRI3CgVidXlpbhgBIAEoCzIoLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5CdXlJbiKmAQoSTGlzdFJlY2FsbHNSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIYCgtjb250cmFjdF9pZBgCIAEoCUgBiAEBEg8KAmlkGAMgASgJSAKIAQESFwoKaW5zdHJ1bWVudBgEIAEoCUgDiAEBQg0KC19yZXF1ZXN0X2lkQg4KDF9jb250cmFjdF9pZEIFCgNfaWRCDQoLX2luc3RydW1lbnQiZgoTTGlzdFJlY2FsbHNSZXNwb25zZRI6CgdyZWNhbGxzGAEgAygLMikuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlJlY2FsbBITCgt0b3RhbF9jb3VudBgCIAEoAyJmChVSZXR1cm5Db250cmFjdFJlcXVlc3QSFwoKcmVxdWVzdF9pZBgBIAEoCUgAiAEBEhMKC2NvbnRyYWN0X2lkGAIgASgJEhAKCHF1YW50aXR5GAMgASgDQg0KC19yZXF1ZXN0X2lkInkKFlJldHVybkNvbnRyYWN0UmVzcG9uc2USEwoLY29udHJhY3RfaWQYASABKAkSSgoPY29udHJhY3RfcmV0dXJuGAIgASgLMjEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNvbnRyYWN0UmV0dXJuImsKIENhbmNlbFNpbmdsZVBlbmRpbmdSZXR1cm5SZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARITCgtjb250cmFjdF9pZBgCIAEoCRIKCgJpZBgDIAEoCUINCgtfcmVxdWVzdF9pZCJECiFDYW5jZWxTaW5nbGVQZW5kaW5nUmV0dXJuUmVzcG9uc2USEwoLY29udHJhY3RfaWQYASABKAkSCgoCaWQYAiABKAkiXQoeQ2FuY2VsQWxsUGVuZGluZ1JldHVybnNSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARITCgtjb250cmFjdF9pZBgCIAEoCUINCgtfcmVxdWVzdF9pZCI2Ch9DYW5jZWxBbGxQZW5kaW5nUmV0dXJuc1Jlc3BvbnNlEhMKC2NvbnRyYWN0X2lkGAEgASgJIu4BChpMaXN0Q29udHJhY3RIaXN0b3J5UmVxdWVzdBJRCgZmaWx0ZXIYASABKAsyPC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuTGlzdENvbnRyYWN0SGlzdG9yeUZpbHRlckgAiAEBEkkKBXNvcnRzGAIgAygLMjouYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkxpc3RDb250cmFjdEhpc3RvcnlTb3J0EhMKC3BhZ2VfbnVtYmVyGAMgASgFEhIKCnBhZ2VfbGltaXQYBCABKAVCCQoHX2ZpbHRlciKxCwoZTGlzdENvbnRyYWN0SGlzdG9yeUZpbHRlchJRCgtldmVudF90eXBlcxgBIAMoDjI8LmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdGhpc3RvcnkuQ29udHJhY3RIaXN0b3J5RXZlbnRUeXBlEh0KEGV2ZW50X3RpbWVfc3RhcnQYAiABKAlIAIgBARIbCg5ldmVudF90aW1lX2VuZBgDIAEoCUgBiAEBEhMKC2luc3RydW1lbnRzGAQgAygJEhYKDmNvdW50ZXJwYXJ0aWVzGAUgAygJEhEKCWNvbnRyYWN0cxgGIAMoCRIyCgRzaWRlGAcgASgOMh8uYXVyb3JhLmNvcmUuY29uc3RzLmNvbW1vbi5TaWRlSAKIAQESYgoOaW5pdGlhdG9yX2tpbmQYCCABKA4yRS5hdXJvcmEuY29yZS5jb25zdHMuY29udHJhY3RoaXN0b3J5LkNvbnRyYWN0SGlzdG9yeUV2ZW50SW5pdGlhdG9yS2luZEgDiAEBEhkKDGluaXRpYXRvcl9pZBgJIAEoCUgEiAEBEkIKDW9wZW5fcXVhbnRpdHkYCiABKAsyJi5hdXJvcmEuY29yZS5jb25zdHMucXVlcnkuQmlnaW50RmlsdGVySAWIAQESRAoOY29udHJhY3RfdmFsdWUYCyABKAsyJy5hdXJvcmEuY29yZS5jb25zdHMucXVlcnkuRGVjaW1hbEZpbHRlckgGiAEBEkkKFG9wZW5fcXVhbnRpdHlfY2hhbmdlGAwgASgLMiYuYXVyb3JhLmNvcmUuY29uc3RzLnF1ZXJ5LkJpZ2ludEZpbHRlckgHiAEBEkcKEHNldHRsZW1lbnRfdHlwZXMYDSADKA4yLS5hdXJvcmEuY29yZS5jb25zdHMuc2V0dGxlbWVudC5TZXR0bGVtZW50VHlwZRI6CgRyYXRlGA4gASgLMicuYXVyb3JhLmNvcmUuY29uc3RzLnF1ZXJ5LkRlY2ltYWxGaWx0ZXJICIgBARJBCgtyYXRlX2Ftb3VudBgPIAEoCzInLmF1cm9yYS5jb3JlLmNvbnN0cy5xdWVyeS5EZWNpbWFsRmlsdGVySAmIAQESEwoGdGlja2VyGBAgASgJSAqIAQESQAoKdW5pdF9wcmljZRgRIAEoCzInLmF1cm9yYS5jb3JlLmNvbnN0cy5xdWVyeS5EZWNpbWFsRmlsdGVySAuIAQESTwoZY29udHJhY3RfdmFsdWVfYWRqdXN0bWVudBgSIAEoCzInLmF1cm9yYS5jb3JlLmNvbnN0cy5xdWVyeS5EZWNpbWFsRmlsdGVySAyIAQESIgoVc2V0dGxlbWVudF9kYXRlX3N0YXJ0GBMgASgJSA2IAQESIAoTc2V0dGxlbWVudF9kYXRlX2VuZBgUIAEoCUgOiAEBEkIKDG1hcmtldF92YWx1ZRgVIAEoCzInLmF1cm9yYS5jb3JlLmNvbnN0cy5xdWVyeS5EZWNpbWFsRmlsdGVySA+IAQESEgoFY3VzaXAYFiABKAlIEIgBAUITChFfZXZlbnRfdGltZV9zdGFydEIRCg9fZXZlbnRfdGltZV9lbmRCBwoFX3NpZGVCEQoPX2luaXRpYXRvcl9raW5kQg8KDV9pbml0aWF0b3JfaWRCEAoOX29wZW5fcXVhbnRpdHlCEQoPX2NvbnRyYWN0X3ZhbHVlQhcKFV9vcGVuX3F1YW50aXR5X2NoYW5nZUIHCgVfcmF0ZUIOCgxfcmF0ZV9hbW91bnRCCQoHX3RpY2tlckINCgtfdW5pdF9wcmljZUIcChpfY29udHJhY3RfdmFsdWVfYWRqdXN0bWVudEIYChZfc2V0dGxlbWVudF9kYXRlX3N0YXJ0QhYKFF9zZXR0bGVtZW50X2RhdGVfZW5kQg8KDV9tYXJrZXRfdmFsdWVCCAoGX2N1c2lwIp4BChdMaXN0Q29udHJhY3RIaXN0b3J5U29ydBJPCgVmaWVsZBgBIAEoDjJALmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdGhpc3RvcnkuQ29udHJhY3RIaXN0b3J5U29ydGFibGVGaWVsZBIyCgVvcmRlchgCIAEoDjIjLmF1cm9yYS5jb3JlLmNvbnN0cy5xdWVyeS5Tb3J0T3JkZXIifQobTGlzdENvbnRyYWN0SGlzdG9yeVJlc3BvbnNlEkcKBmV2ZW50cxgBIAMoCzI3LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5Db250cmFjdEhpc3RvcnlFdmVudBIVCg10b3RhbF9lbnRyaWVzGAIgASgDIvIBChRDb250cmFjdEhpc3RvcnlFdmVudBIQCghldmVudF9pZBgBIAEoCRJQCgpldmVudF90eXBlGAIgASgOMjwuYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0aGlzdG9yeS5Db250cmFjdEhpc3RvcnlFdmVudFR5cGUSEgoKZXZlbnRfdGltZRgDIAEoCRIRCglpbml0aWF0b3IYBCABKAkSTwoOY29udHJhY3Rfc3RhdGUYBSABKAsyNy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ29udHJhY3RIaXN0b3J5U3RhdGUi7QYKFENvbnRyYWN0SGlzdG9yeVN0YXRlEgoKAmlkGAIgASgJEkYKD3NldHRsZW1lbnRfdHlwZRgDIAEoDjItLmF1cm9yYS5jb3JlLmNvbnN0cy5zZXR0bGVtZW50LlNldHRsZW1lbnRUeXBlEjsKCmluc3RydW1lbnQYBCABKAsyJy5hdXJvcmEuY29yZS5jb21tb24ucHJvdG9zLlBiSW5zdHJ1bWVudBItCgRzaWRlGAUgASgOMh8uYXVyb3JhLmNvcmUuY29uc3RzLmNvbW1vbi5TaWRlEhcKD2NvdW50ZXJwYXJ0eV9pZBgGIAEoCRIWCg50b3RhbF9xdWFudGl0eRgHIAEoAxIVCg1vcGVuX3F1YW50aXR5GAggASgDEhIKCnVuaXRfcHJpY2UYCSABKAkSPgoMcmF0ZV9kZXRhaWxzGAogASgLMiguYXVyb3JhLmNvcmUuY29tbW9uLnByb3Rvcy5QYlJhdGVEZXRhaWxzEhYKDmNvbnRyYWN0X3ZhbHVlGAsgASgJEhsKE2ludGVyZXN0X2R1ZV9hbW91bnQYDCABKAkSFAoMbWFya2V0X3ZhbHVlGA0gASgJEh8KF21hcmtldF92YWx1ZV9hZGp1c3RtZW50GA4gASgJEiEKGWNvbnRyYWN0X3ZhbHVlX2FkanVzdG1lbnQYDyABKAkSHAoUb3Blbl9xdWFudGl0eV9jaGFuZ2UYECABKAMSFQoNc2V0dGxlbWVudF9pZBgRIAEoCRIXCg9zZXR0bGVtZW50X2RhdGUYEyABKAkSFwoPY29sbGF0ZXJhbF9yYXRlGBUgASgJEhkKDGFncmVlbWVudF9pZBgWIAEoCUgAiAEBEjIKBnN0YXR1cxgXIAEoDjIiLmF1cm9yYS5jb3JlLmNvbnN0cy5Db250cmFjdFN0YXR1cxI3Cg1yb3VuZGluZ19ydWxlGBggASgOMiAuYXVyb3JhLmNvcmUuY29uc3RzLlJvdW5kaW5nUnVsZRIZChFyZWNhbGxlZF9xdWFudGl0eRgZIAEoAxIZChFyZXR1cm5lZF9xdWFudGl0eRgaIAEoAxISCgpjcmVhdGVkX2F0GBIgASgJEhoKEmF1cm9yYV9pbnRlcm5hbF9pZBgBIAEoCUIPCg1fYWdyZWVtZW50X2lkSgQIFBAVIlkKI0FjY2VwdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIKCgJpZBgCIAEoCUINCgtfcmVxdWVzdF9pZCIyCiRBY2NlcHRBd2FpdGluZ0NvbnRyYWN0UmV0dXJuUmVzcG9uc2USCgoCaWQYASABKAkiWQojUmVqZWN0QXdhaXRpbmdDb250cmFjdFJldHVyblJlcXVlc3QSFwoKcmVxdWVzdF9pZBgBIAEoCUgAiAEBEgoKAmlkGAIgASgJQg0KC19yZXF1ZXN0X2lkIjIKJFJlamVjdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXNwb25zZRIKCgJpZBgBIAEoCSJZCiNDYW5jZWxBd2FpdGluZ0NvbnRyYWN0UmV0dXJuUmVxdWVzdBIXCgpyZXF1ZXN0X2lkGAEgASgJSACIAQESCgoCaWQYAiABKAlCDQoLX3JlcXVlc3RfaWQiMgokQ2FuY2VsQXdhaXRpbmdDb250cmFjdFJldHVyblJlc3BvbnNlEgoKAmlkGAEgASgJIpwBCh1DcmVhdGVSYXRlTW9kaWZpY2F0aW9uUmVxdWVzdBIXCgpyZXF1ZXN0X2lkGAEgASgJSACIAQESEwoLY29udHJhY3RfaWQYAiABKAkSPgoMcmF0ZV9kZXRhaWxzGAMgASgLMiguYXVyb3JhLmNvcmUuY29tbW9uLnByb3Rvcy5QYlJhdGVEZXRhaWxzQg0KC19yZXF1ZXN0X2lkIt4BCh5DcmVhdGVSYXRlTW9kaWZpY2F0aW9uUmVzcG9uc2USCgoCaWQYASABKAkSWwoGc3RhdHVzGAIgASgOMksuYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0cmF0ZW1vZGlmaWNhdGlvbi5Db250cmFjdFJhdGVNb2RpZmljYXRpb25TdGF0dXMSEwoLY29udHJhY3RfaWQYAyABKAkSPgoMcmF0ZV9kZXRhaWxzGAQgASgLMiguYXVyb3JhLmNvcmUuY29tbW9uLnByb3Rvcy5QYlJhdGVEZXRhaWxzIlMKHVVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIKCgJpZBgCIAEoCUINCgtfcmVxdWVzdF9pZCKJAQoeVXBkYXRlUmF0ZU1vZGlmaWNhdGlvblJlc3BvbnNlEgoKAmlkGAEgASgJElsKBnN0YXR1cxgCIAEoDjJLLmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdHJhdGVtb2RpZmljYXRpb24uQ29udHJhY3RSYXRlTW9kaWZpY2F0aW9uU3RhdHVzIocCChxMaXN0UmF0ZU1vZGlmaWNhdGlvbnNSZXF1ZXN0EhcKCnJlcXVlc3RfaWQYASABKAlIAIgBARIPCgJpZBgCIAEoCUgBiAEBEhgKC2NvbnRyYWN0X2lkGAMgASgJSAKIAQESFwoKaW5zdHJ1bWVudBgEIAEoCUgDiAEBEjIKBHNpZGUYBSABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGVIBIgBARIYChBjb3VudGVycGFydHlfaWRzGAYgAygJQg0KC19yZXF1ZXN0X2lkQgUKA19pZEIOCgxfY29udHJhY3RfaWRCDQoLX2luc3RydW1lbnRCBwoFX3NpZGUijAEKHUxpc3RSYXRlTW9kaWZpY2F0aW9uc1Jlc3BvbnNlElYKEnJhdGVfbW9kaWZpY2F0aW9ucxgBIAMoCzI6LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5SYXRlTW9kaWZpY2F0aW9uRGV0YWlscxITCgt0b3RhbF9jb3VudBgCIAEoAyKuAgoXUmF0ZU1vZGlmaWNhdGlvbkRldGFpbHMSCgoCaWQYASABKAkSEwoLY29udHJhY3RfaWQYAiABKAkSWwoGc3RhdHVzGAMgASgOMksuYXVyb3JhLmNvcmUuY29uc3RzLmNvbnRyYWN0cmF0ZW1vZGlmaWNhdGlvbi5Db250cmFjdFJhdGVNb2RpZmljYXRpb25TdGF0dXMSNgoEcmF0ZRgEIAEoCzIoLmF1cm9yYS5jb3JlLmNvbW1vbi5wcm90b3MuUGJSYXRlRGV0YWlscxI/Cg1vcmlnaW5hbF9yYXRlGAUgASgLMiguYXVyb3JhLmNvcmUuY29tbW9uLnByb3Rvcy5QYlJhdGVEZXRhaWxzEhwKFGluaXRpYXRvcl9jb21wYW55X2lkGAYgASgJIowBCg5Db250cmFjdFJldHVybhIKCgJpZBgBIAEoCRITCgtjb250cmFjdF9pZBgCIAEoCRIQCghxdWFudGl0eRgDIAEoAxJHCgZzdGF0dXMYBCABKA4yNy5hdXJvcmEuY29yZS5jb25zdHMuY29udHJhY3RyZXR1cm4uQ29udHJhY3RSZXR1cm5TdGF0dXMikAEKBUJ1eUluEgoKAmlkGAEgASgJEhMKC2NvbnRyYWN0X2lkGAIgASgJEhAKCHF1YW50aXR5GAMgASgDEg0KBXByaWNlGAQgASgJEkUKBnN0YXR1cxgFIAEoDjI1LmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdGJ1eWluLkNvbnRyYWN0QnV5SW5TdGF0dXMirwMKHUNyZWF0ZUNvbnRyYWN0UHJvcG9zYWxSZXF1ZXN0EhIKCnJlcXVlc3RfaWQYASABKAkSEgoKaW5zdHJ1bWVudBgCIAEoCRIQCghxdWFudGl0eRgDIAEoAxI+CgxyYXRlX2RldGFpbHMYBCABKAsyKC5hdXJvcmEuY29yZS5jb21tb24ucHJvdG9zLlBiUmF0ZURldGFpbHMSFwoPY29sbGF0ZXJhbF9yYXRlGAUgASgJEjcKDXJvdW5kaW5nX3J1bGUYBiABKA4yIC5hdXJvcmEuY29yZS5jb25zdHMuUm91bmRpbmdSdWxlEhkKEWluc3RydWN0X2RlbGl2ZXJ5GAcgASgIEi0KBHNpZGUYCSABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGUSFwoPY291bnRlcnBhcnR5X2lkGAogASgJEksKD3NldHRsZW1lbnRfdHlwZRgLIAEoDjItLmF1cm9yYS5jb3JlLmNvbnN0cy5zZXR0bGVtZW50LlNldHRsZW1lbnRUeXBlSACIAQFCEgoQX3NldHRsZW1lbnRfdHlwZSJ8Ch1BY2NlcHRDb250cmFjdFByb3Bvc2FsUmVxdWVzdBIKCgJpZBgBIAEoCRIUCgdjb21tZW50GAIgASgJSACIAQESLQoEc2lkZRgDIAEoDjIfLmF1cm9yYS5jb3JlLmNvbnN0cy5jb21tb24uU2lkZUIKCghfY29tbWVudCJ9Ch5EZWNsaW5lQ29udHJhY3RQcm9wb3NhbFJlcXVlc3QSCgoCaWQYASABKAkSFAoHY29tbWVudBgCIAEoCUgAiAEBEi0KBHNpZGUYAyABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGVCCgoIX2NvbW1lbnQifAodQ2FuY2VsQ29udHJhY3RQcm9wb3NhbFJlcXVlc3QSCgoCaWQYASABKAkSFAoHY29tbWVudBgCIAEoCUgAiAEBEi0KBHNpZGUYAyABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGVCCgoIX2NvbW1lbnQi7gMKHExpc3RDb250cmFjdFByb3Bvc2Fsc1JlcXVlc3QSFwoKaW5zdHJ1bWVudBgBIAEoCUgAiAEBEhcKCnJlcXVlc3RfaWQYAiABKAlIAYgBARIYChBjb3VudGVycGFydHlfaWRzGAMgAygJEjIKBHNpZGUYBCABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGVIAogBARIeChFpbnN0cnVjdF9kZWxpdmVyeRgFIAEoCEgDiAEBEkkKBnN0YXR1cxgGIAMoDjI5LmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdHJlcXVlc3QuQ29udHJhY3RSZXF1ZXN0U3RhdHVzEhUKDWluaXRpYXRvcl9pZHMYByADKAkSFwoKY3JlYXRlZF9ieRgIIAEoCUgEiAEBEhcKCnVwZGF0ZWRfYnkYCSABKAlIBYgBARIPCgJpZBgMIAEoCUgGiAEBEhMKC3BhZ2VfbnVtYmVyGAogASgFEhIKCnBhZ2VfbGltaXQYCyABKAVCDQoLX2luc3RydW1lbnRCDQoLX3JlcXVlc3RfaWRCBwoFX3NpZGVCFAoSX2luc3RydWN0X2RlbGl2ZXJ5Qg0KC19jcmVhdGVkX2J5Qg0KC191cGRhdGVkX2J5QgUKA19pZCL9BQoQQ29udHJhY3RQcm9wb3NhbBISCgpyZXF1ZXN0X2lkGAEgASgJEi0KBHNpZGUYAiABKA4yHy5hdXJvcmEuY29yZS5jb25zdHMuY29tbW9uLlNpZGUSFwoPY291bnRlcnBhcnR5X2lkGAMgASgJEhAKCHF1YW50aXR5GAQgASgDEjcKDXJvdW5kaW5nX3J1bGUYBSABKA4yIC5hdXJvcmEuY29yZS5jb25zdHMuUm91bmRpbmdSdWxlEgoKAmlkGAYgASgJEkkKBnN0YXR1cxgHIAEoDjI5LmF1cm9yYS5jb3JlLmNvbnN0cy5jb250cmFjdHJlcXVlc3QuQ29udHJhY3RSZXF1ZXN0U3RhdHVzEhQKB2NvbW1lbnQYCCABKAlIAIgBARI+CgxyYXRlX2RldGFpbHMYCSABKAsyKC5hdXJvcmEuY29yZS5jb21tb24ucHJvdG9zLlBiUmF0ZURldGFpbHMSFwoPY29sbGF0ZXJhbF9yYXRlGAogASgJEjsKCmluc3RydW1lbnQYCyABKAsyJy5hdXJvcmEuY29yZS5jb21tb24ucHJvdG9zLlBiSW5zdHJ1bWVudBIYCgtjb250cmFjdF9pZBgMIAEoCUgBiAEBEiAKE2NvbnRyYWN0X2Rpc3BsYXlfaWQYDSABKAlIAogBARIZChFpbnN0cnVjdF9kZWxpdmVyeRgOIAEoCBJGCg9zZXR0bGVtZW50X3R5cGUYDyABKA4yLS5hdXJvcmEuY29yZS5jb25zdHMuc2V0dGxlbWVudC5TZXR0bGVtZW50VHlwZRIcChRpbml0aWF0b3JfY29tcGFueV9pZBgQIAEoCRISCgpjcmVhdGVkX2F0GBEgASgJEhIKCnVwZGF0ZWRfYXQYEiABKAkSEgoKY3JlYXRlZF9ieRgTIAEoCRISCgp1cGRhdGVkX2J5GBQgASgJQgoKCF9jb21tZW50Qg4KDF9jb250cmFjdF9pZEIWChRfY29udHJhY3RfZGlzcGxheV9pZCKqAQodTGlzdENvbnRyYWN0UHJvcG9zYWxzUmVzcG9uc2USIAoTbnVtYmVyX29mX2NvbnRyYWN0cxgBIAEoA0gAiAEBEk8KEmNvbnRyYWN0X3Byb3Bvc2FscxgCIAMoCzIzLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5Db250cmFjdFByb3Bvc2FsQhYKFF9udW1iZXJfb2ZfY29udHJhY3RzKjEKGUxpc3RDb250cmFjdHNTdGF0dXNGaWx0ZXISCAoET1BFThAAEgoKBkNMT1NFRBABMoYeCg9Db250cmFjdFNlcnZpY2USfgoLR2V0Q29udHJhY3QSNS5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuR2V0Q29udHJhY3RSZXF1ZXN0GjYuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkdldENvbnRyYWN0UmVzcG9uc2UiABKEAQoNTGlzdENvbnRyYWN0cxI3LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5MaXN0Q29udHJhY3RzUmVxdWVzdBo4LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5MaXN0Q29udHJhY3RzUmVzcG9uc2UiABKHAQoOQ2FuY2VsQ29udHJhY3QSOC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ2FuY2VsQ29udHJhY3RSZXF1ZXN0GjkuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbENvbnRyYWN0UmVzcG9uc2UiABKHAQoOUmVjYWxsQ29udHJhY3QSOC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuUmVjYWxsQ29udHJhY3RSZXF1ZXN0GjkuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlJlY2FsbENvbnRyYWN0UmVzcG9uc2UiABKZAQoUQ2FuY2VsUmVjYWxsQ29udHJhY3QSPi5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ2FuY2VsUmVjYWxsQ29udHJhY3RSZXF1ZXN0Gj8uYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbFJlY2FsbENvbnRyYWN0UmVzcG9uc2UiABKEAQoNQnV5SW5Db250cmFjdBI3LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5CdXlJbkNvbnRyYWN0UmVxdWVzdBo4LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5CdXlJbkNvbnRyYWN0UmVzcG9uc2UiABJ+CgtMaXN0UmVjYWxscxI1LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5MaXN0UmVjYWxsc1JlcXVlc3QaNi5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuTGlzdFJlY2FsbHNSZXNwb25zZSIAEo0BChBDYW5jZWxBbGxSZWNhbGxzEjouYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbEFsbFJlY2FsbHNSZXF1ZXN0GjsuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbEFsbFJlY2FsbHNSZXNwb25zZSIAEocBCg5SZXR1cm5Db250cmFjdBI4LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5SZXR1cm5Db250cmFjdFJlcXVlc3QaOS5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuUmV0dXJuQ29udHJhY3RSZXNwb25zZSIAEqIBChdDYW5jZWxBbGxQZW5kaW5nUmV0dXJucxJBLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5DYW5jZWxBbGxQZW5kaW5nUmV0dXJuc1JlcXVlc3QaQi5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ2FuY2VsQWxsUGVuZGluZ1JldHVybnNSZXNwb25zZSIAEqgBChlDYW5jZWxTaW5nbGVQZW5kaW5nUmV0dXJuEkMuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbFNpbmdsZVBlbmRpbmdSZXR1cm5SZXF1ZXN0GkQuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbFNpbmdsZVBlbmRpbmdSZXR1cm5SZXNwb25zZSIAErEBChxBY2NlcHRBd2FpdGluZ0NvbnRyYWN0UmV0dXJuEkYuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkFjY2VwdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXF1ZXN0GkcuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkFjY2VwdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXNwb25zZSIAErEBChxSZWplY3RBd2FpdGluZ0NvbnRyYWN0UmV0dXJuEkYuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlJlamVjdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXF1ZXN0GkcuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlJlamVjdEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXNwb25zZSIAErEBChxDYW5jZWxBd2FpdGluZ0NvbnRyYWN0UmV0dXJuEkYuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXF1ZXN0GkcuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNhbmNlbEF3YWl0aW5nQ29udHJhY3RSZXR1cm5SZXNwb25zZSIAEpYBChNMaXN0Q29udHJhY3RIaXN0b3J5Ej0uYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkxpc3RDb250cmFjdEhpc3RvcnlSZXF1ZXN0Gj4uYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkxpc3RDb250cmFjdEhpc3RvcnlSZXNwb25zZSIAEp8BChZDcmVhdGVSYXRlTW9kaWZpY2F0aW9uEkAuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNyZWF0ZVJhdGVNb2RpZmljYXRpb25SZXF1ZXN0GkEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNyZWF0ZVJhdGVNb2RpZmljYXRpb25SZXNwb25zZSIAEp8BChZDYW5jZWxSYXRlTW9kaWZpY2F0aW9uEkAuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXF1ZXN0GkEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXNwb25zZSIAEp8BChZBY2NlcHRSYXRlTW9kaWZpY2F0aW9uEkAuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXF1ZXN0GkEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXNwb25zZSIAEp8BChZSZWplY3RSYXRlTW9kaWZpY2F0aW9uEkAuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXF1ZXN0GkEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLlVwZGF0ZVJhdGVNb2RpZmljYXRpb25SZXNwb25zZSIAEpwBChVMaXN0UmF0ZU1vZGlmaWNhdGlvbnMSPy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuTGlzdFJhdGVNb2RpZmljYXRpb25zUmVxdWVzdBpALmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5MaXN0UmF0ZU1vZGlmaWNhdGlvbnNSZXNwb25zZSIAEpEBChZDcmVhdGVDb250cmFjdFByb3Bvc2FsEkAuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNyZWF0ZUNvbnRyYWN0UHJvcG9zYWxSZXF1ZXN0GjMuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkNvbnRyYWN0UHJvcG9zYWwiABKRAQoWQWNjZXB0Q29udHJhY3RQcm9wb3NhbBJALmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5BY2NlcHRDb250cmFjdFByb3Bvc2FsUmVxdWVzdBozLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5Db250cmFjdFByb3Bvc2FsIgASkwEKF0RlY2xpbmVDb250cmFjdFByb3Bvc2FsEkEuYXVyb3JhLmNvcmUuYXBpZW5naW5lLmNvbnRyYWN0c3YxLkRlY2xpbmVDb250cmFjdFByb3Bvc2FsUmVxdWVzdBozLmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5Db250cmFjdFByb3Bvc2FsIgASkQEKFkNhbmNlbENvbnRyYWN0UHJvcG9zYWwSQC5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ2FuY2VsQ29udHJhY3RQcm9wb3NhbFJlcXVlc3QaMy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuQ29udHJhY3RQcm9wb3NhbCIAEpwBChVMaXN0Q29udHJhY3RQcm9wb3NhbHMSPy5hdXJvcmEuY29yZS5hcGllbmdpbmUuY29udHJhY3RzdjEuTGlzdENvbnRyYWN0UHJvcG9zYWxzUmVxdWVzdBpALmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5jb250cmFjdHN2MS5MaXN0Q29udHJhY3RQcm9wb3NhbHNSZXNwb25zZSIAQkRaQmdpdGxhYi5wcnZibC5jb20vYXVyb3JhL2NvcmUvc3JjL21vZHVsZXMvYXBpZW5naW5lL2FwaS9jb250cmFjdHN2MWIGcHJvdG8z", [file_common_protos_types, file_consts_loanconsts, file_consts_loanrequestconsts, file_consts_commonconsts, file_consts_loanrecallconsts, file_consts_loanbuyinconsts, file_consts_settlementconsts, file_consts_queryconsts, file_consts_loanhistoryconsts, file_consts_loanreturnconsts, file_consts_ratemodificationconsts]);

/**
 * @generated from message aurora.core.apiengine.contractsv1.GetContractRequest
 */
export type GetContractRequest = Message<"aurora.core.apiengine.contractsv1.GetContractRequest"> & {
  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.GetContractRequest.
 * Use `create(GetContractRequestSchema)` to create a new message.
 */
export const GetContractRequestSchema: GenMessage<GetContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 0);

/**
 * @generated from message aurora.core.apiengine.contractsv1.GetContractResponse
 */
export type GetContractResponse = Message<"aurora.core.apiengine.contractsv1.GetContractResponse"> & {
  /**
   * Contract Details
   *
   * @generated from field: aurora.core.apiengine.contractsv1.Contract contract = 1;
   */
  contract?: Contract;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.GetContractResponse.
 * Use `create(GetContractResponseSchema)` to create a new message.
 */
export const GetContractResponseSchema: GenMessage<GetContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 1);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelContractRequest
 */
export type CancelContractRequest = Message<"aurora.core.apiengine.contractsv1.CancelContractRequest"> & {
  /**
   * User populated id of this request
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelContractRequest.
 * Use `create(CancelContractRequestSchema)` to create a new message.
 */
export const CancelContractRequestSchema: GenMessage<CancelContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 2);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelContractResponse
 */
export type CancelContractResponse = Message<"aurora.core.apiengine.contractsv1.CancelContractResponse"> & {
  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelContractResponse.
 * Use `create(CancelContractResponseSchema)` to create a new message.
 */
export const CancelContractResponseSchema: GenMessage<CancelContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 3);

/**
 * @generated from message aurora.core.apiengine.contractsv1.Recall
 */
export type Recall = Message<"aurora.core.apiengine.contractsv1.Recall"> & {
  /**
   * Recall identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Status of the recall
   *
   * @generated from field: aurora.core.consts.contractrecall.ContractRecallStatus recall_status = 3;
   */
  recallStatus: ContractRecallStatus;

  /**
   * Number of shares recalled
   *
   * @generated from field: int64 quantity = 4;
   */
  quantity: bigint;

  /**
   * allowed buy-in execution date
   *
   * @generated from field: optional string allowed_execution_date = 5;
   */
  allowedExecutionDate?: string;

  /**
   * Company ID that initiated this recall (always the lender)
   *
   * @generated from field: string initiator_company_id = 6;
   */
  initiatorCompanyId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.Recall.
 * Use `create(RecallSchema)` to create a new message.
 */
export const RecallSchema: GenMessage<Recall> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 4);

/**
 * @generated from message aurora.core.apiengine.contractsv1.RecallContractRequest
 */
export type RecallContractRequest = Message<"aurora.core.apiengine.contractsv1.RecallContractRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Amount of shares to recall
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.RecallContractRequest.
 * Use `create(RecallContractRequestSchema)` to create a new message.
 */
export const RecallContractRequestSchema: GenMessage<RecallContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 5);

/**
 * @generated from message aurora.core.apiengine.contractsv1.RecallContractResponse
 */
export type RecallContractResponse = Message<"aurora.core.apiengine.contractsv1.RecallContractResponse"> & {
  /**
   * Recall details
   *
   * @generated from field: aurora.core.apiengine.contractsv1.Recall recall = 1;
   */
  recall?: Recall;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.RecallContractResponse.
 * Use `create(RecallContractResponseSchema)` to create a new message.
 */
export const RecallContractResponseSchema: GenMessage<RecallContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 6);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractsRequest
 */
export type ListContractsRequest = Message<"aurora.core.apiengine.contractsv1.ListContractsRequest"> & {
  /**
   * Filter contracts by status
   *
   * @generated from field: optional aurora.core.apiengine.contractsv1.ListContractsStatusFilter status_filter = 1;
   */
  statusFilter?: ListContractsStatusFilter;

  /**
   * Contract identifier (persistent contract identifier inside Aurora system) filter
   *
   * @generated from field: optional string id = 2;
   */
  id?: string;

  /**
   * Contracts closed on selected date (YYYY-MM-DD) filter
   *
   * @generated from field: optional string closed_date = 4;
   */
  closedDate?: string;

  /**
   * Side (lender or borrower) filter
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 5;
   */
  side?: Side;

  /**
   * Counterparty ID filter
   *
   * @generated from field: repeated string counterparty_ids = 6;
   */
  counterpartyIds: string[];

  /**
   * Instrument (CUSIP or Ticker) filter
   *
   * @generated from field: optional string instrument = 7;
   */
  instrument?: string;

  /**
   * Filter contracts created after time - in RFC3339 with millisecond precision
   *
   * @generated from field: optional string created_at_start = 8;
   */
  createdAtStart?: string;

  /**
   * Filter contracts created before time - in RFC3339 with millisecond precision
   *
   * @generated from field: optional string created_at_end = 9;
   */
  createdAtEnd?: string;

  /**
   * Page number to fetch, starting from 1
   *
   * @generated from field: int32 page_number = 10;
   */
  pageNumber: number;

  /**
   * Number of contracts to fetch per page (max=1000)
   *
   * @generated from field: int32 page_limit = 11;
   */
  pageLimit: number;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractsRequest.
 * Use `create(ListContractsRequestSchema)` to create a new message.
 */
export const ListContractsRequestSchema: GenMessage<ListContractsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 7);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractsResponse
 */
export type ListContractsResponse = Message<"aurora.core.apiengine.contractsv1.ListContractsResponse"> & {
  /**
   * Current details of the contract(s)
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.Contract contracts = 1;
   */
  contracts: Contract[];

  /**
   * Total number of contracts
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractsResponse.
 * Use `create(ListContractsResponseSchema)` to create a new message.
 */
export const ListContractsResponseSchema: GenMessage<ListContractsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 8);

/**
 * Current status of the contract according to Aurora
 *
 * @generated from message aurora.core.apiengine.contractsv1.Contract
 */
export type Contract = Message<"aurora.core.apiengine.contractsv1.Contract"> & {
  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Settlement Type of the contract
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 2;
   */
  settlementType: SettlementType;

  /**
   * Settlement Type specific identifier
   * ie. DTCC reference id for SFT
   *
   * @generated from field: string settlement_id = 3;
   */
  settlementId: string;

  /**
   * Instrument
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 4;
   */
  instrument?: PbInstrument;

  /**
   * Side (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 5;
   */
  side: Side;

  /**
   * Counterparty ID
   *
   * @generated from field: string counterparty_id = 6;
   */
  counterpartyId: string;

  /**
   * Status of the contract
   *
   * @generated from field: aurora.core.consts.ContractStatus status = 7;
   */
  status: ContractStatus;

  /**
   * Total quantity of the contract
   *
   * @generated from field: int64 quantity = 8;
   */
  quantity: bigint;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 9;
   */
  rateDetails?: PbRateDetails;

  /**
   * Collateral rate of the contract
   *
   * @generated from field: string collateral_rate = 10;
   */
  collateralRate: string;

  /**
   * Rounding Rule for the contract
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 11;
   */
  roundingRule: RoundingRule;

  /**
   * Daily interest amount of the contract
   *
   * @generated from field: string interest_due_amount = 12;
   */
  interestDueAmount: string;

  /**
   * Market value of the contract
   *
   * @generated from field: string market_value = 13;
   */
  marketValue: string;

  /**
   * Value of the contract
   *
   * @generated from field: string contract_value = 14;
   */
  contractValue: string;

  /**
   * Change in value of the contract
   *
   * @generated from field: string contract_value_adjustment = 15;
   */
  contractValueAdjustment: string;

  /**
   * Time of contract creation- time in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 16;
   */
  createdAt: string;

  /**
   * Settlement date of SFT (if exists)
   *
   * @generated from field: string settlement_date = 17;
   */
  settlementDate: string;

  /**
   * Total quantity currently recalled
   *
   * @generated from field: int64 recalled_quantity = 18;
   */
  recalledQuantity: bigint;

  /**
   * Total quantity that has been returned
   *
   * @generated from field: int64 returned_quantity = 19;
   */
  returnedQuantity: bigint;

  /**
   * Id of the agreement associated with this contract
   *
   * @generated from field: optional string agreement_id = 20;
   */
  agreementId?: string;

  /**
   * Last prior day market price
   *
   * @generated from field: string unit_price = 21;
   */
  unitPrice: string;

  /**
   * Quantity of the contract before the last operation that adjusted this value
   *
   * @generated from field: int64 last_quantity = 22;
   */
  lastQuantity: bigint;

  /**
   * Market value of the contract before the last operation that adjusted this value
   *
   * @generated from field: string last_market_value = 23;
   */
  lastMarketValue: string;

  /**
   * Value of the contract before the last operation that adjusted this value
   *
   * @generated from field: string last_contract_value = 24;
   */
  lastContractValue: string;

  /**
   * The collateral_rate adjusted price rounded up.
   *
   * @generated from field: string collateral_price = 25;
   */
  collateralPrice: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.Contract.
 * Use `create(ContractSchema)` to create a new message.
 */
export const ContractSchema: GenMessage<Contract> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 9);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelRecallContractRequest
 */
export type CancelRecallContractRequest = Message<"aurora.core.apiengine.contractsv1.CancelRecallContractRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Identifier of the recall to cancel (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 3;
   */
  contractId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelRecallContractRequest.
 * Use `create(CancelRecallContractRequestSchema)` to create a new message.
 */
export const CancelRecallContractRequestSchema: GenMessage<CancelRecallContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 10);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelRecallContractResponse
 */
export type CancelRecallContractResponse = Message<"aurora.core.apiengine.contractsv1.CancelRecallContractResponse"> & {
  /**
   * Recall details after cancellation
   *
   * @generated from field: aurora.core.apiengine.contractsv1.Recall recall = 1;
   */
  recall?: Recall;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelRecallContractResponse.
 * Use `create(CancelRecallContractResponseSchema)` to create a new message.
 */
export const CancelRecallContractResponseSchema: GenMessage<CancelRecallContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 11);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAllRecallsRequest
 */
export type CancelAllRecallsRequest = Message<"aurora.core.apiengine.contractsv1.CancelAllRecallsRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAllRecallsRequest.
 * Use `create(CancelAllRecallsRequestSchema)` to create a new message.
 */
export const CancelAllRecallsRequestSchema: GenMessage<CancelAllRecallsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 12);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAllRecallsResponse
 */
export type CancelAllRecallsResponse = Message<"aurora.core.apiengine.contractsv1.CancelAllRecallsResponse"> & {
  /**
   * Contract identifier (persistent contract identifier inside Aurora system)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAllRecallsResponse.
 * Use `create(CancelAllRecallsResponseSchema)` to create a new message.
 */
export const CancelAllRecallsResponseSchema: GenMessage<CancelAllRecallsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 13);

/**
 * @generated from message aurora.core.apiengine.contractsv1.BuyInContractRequest
 */
export type BuyInContractRequest = Message<"aurora.core.apiengine.contractsv1.BuyInContractRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent contract identifier inside Aurora system)
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Amount of shares to buy-in
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Average price per share for buy-in
   *
   * @generated from field: string avg_price_per_share = 4;
   */
  avgPricePerShare: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.BuyInContractRequest.
 * Use `create(BuyInContractRequestSchema)` to create a new message.
 */
export const BuyInContractRequestSchema: GenMessage<BuyInContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 14);

/**
 * Returns current status of the `BuyIn` request
 *
 * @generated from message aurora.core.apiengine.contractsv1.BuyInContractResponse
 */
export type BuyInContractResponse = Message<"aurora.core.apiengine.contractsv1.BuyInContractResponse"> & {
  /**
   * The details of the buyin
   *
   * @generated from field: aurora.core.apiengine.contractsv1.BuyIn buyin = 1;
   */
  buyin?: BuyIn;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.BuyInContractResponse.
 * Use `create(BuyInContractResponseSchema)` to create a new message.
 */
export const BuyInContractResponseSchema: GenMessage<BuyInContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 15);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListRecallsRequest
 */
export type ListRecallsRequest = Message<"aurora.core.apiengine.contractsv1.ListRecallsRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: optional string contract_id = 2;
   */
  contractId?: string;

  /**
   * Recall id (persistent recall identifier inside Aurora system)
   *
   * @generated from field: optional string id = 3;
   */
  id?: string;

  /**
   * Instrument (CUSIP or Ticker)
   *
   * @generated from field: optional string instrument = 4;
   */
  instrument?: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListRecallsRequest.
 * Use `create(ListRecallsRequestSchema)` to create a new message.
 */
export const ListRecallsRequestSchema: GenMessage<ListRecallsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 16);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListRecallsResponse
 */
export type ListRecallsResponse = Message<"aurora.core.apiengine.contractsv1.ListRecallsResponse"> & {
  /**
   * Details of the recall(s)
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.Recall recalls = 1;
   */
  recalls: Recall[];

  /**
   * Total number of recalls
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListRecallsResponse.
 * Use `create(ListRecallsResponseSchema)` to create a new message.
 */
export const ListRecallsResponseSchema: GenMessage<ListRecallsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 17);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ReturnContractRequest
 */
export type ReturnContractRequest = Message<"aurora.core.apiengine.contractsv1.ReturnContractRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent contract identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Amount of shares to return
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ReturnContractRequest.
 * Use `create(ReturnContractRequestSchema)` to create a new message.
 */
export const ReturnContractRequestSchema: GenMessage<ReturnContractRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 18);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ReturnContractResponse
 */
export type ReturnContractResponse = Message<"aurora.core.apiengine.contractsv1.ReturnContractResponse"> & {
  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * The details of the return (ID, quantity, status, etc)
   *
   * @generated from field: aurora.core.apiengine.contractsv1.ContractReturn contract_return = 2;
   */
  contractReturn?: ContractReturn;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ReturnContractResponse.
 * Use `create(ReturnContractResponseSchema)` to create a new message.
 */
export const ReturnContractResponseSchema: GenMessage<ReturnContractResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 19);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelSinglePendingReturnRequest
 */
export type CancelSinglePendingReturnRequest = Message<"aurora.core.apiengine.contractsv1.CancelSinglePendingReturnRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent contract id inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Return identifier to be canceled (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 3;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelSinglePendingReturnRequest.
 * Use `create(CancelSinglePendingReturnRequestSchema)` to create a new message.
 */
export const CancelSinglePendingReturnRequestSchema: GenMessage<CancelSinglePendingReturnRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 20);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelSinglePendingReturnResponse
 */
export type CancelSinglePendingReturnResponse = Message<"aurora.core.apiengine.contractsv1.CancelSinglePendingReturnResponse"> & {
  /**
   * Contract identifier (persistent contract id inside Aurora system)
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;

  /**
   * Return identifier which is canceled (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelSinglePendingReturnResponse.
 * Use `create(CancelSinglePendingReturnResponseSchema)` to create a new message.
 */
export const CancelSinglePendingReturnResponseSchema: GenMessage<CancelSinglePendingReturnResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 21);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAllPendingReturnsRequest
 */
export type CancelAllPendingReturnsRequest = Message<"aurora.core.apiengine.contractsv1.CancelAllPendingReturnsRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent contract identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAllPendingReturnsRequest.
 * Use `create(CancelAllPendingReturnsRequestSchema)` to create a new message.
 */
export const CancelAllPendingReturnsRequestSchema: GenMessage<CancelAllPendingReturnsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 22);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAllPendingReturnsResponse
 */
export type CancelAllPendingReturnsResponse = Message<"aurora.core.apiengine.contractsv1.CancelAllPendingReturnsResponse"> & {
  /**
   * Contract identifier (persistent contract identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 1;
   */
  contractId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAllPendingReturnsResponse.
 * Use `create(CancelAllPendingReturnsResponseSchema)` to create a new message.
 */
export const CancelAllPendingReturnsResponseSchema: GenMessage<CancelAllPendingReturnsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 23);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractHistoryRequest
 */
export type ListContractHistoryRequest = Message<"aurora.core.apiengine.contractsv1.ListContractHistoryRequest"> & {
  /**
   * Filters can be specified to return a subset of events
   *
   * @generated from field: optional aurora.core.apiengine.contractsv1.ListContractHistoryFilter filter = 1;
   */
  filter?: ListContractHistoryFilter;

  /**
   * Sorting options, multiple can be specified
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.ListContractHistorySort sorts = 2;
   */
  sorts: ListContractHistorySort[];

  /**
   * Page number to fetch, starting from 1
   *
   * @generated from field: int32 page_number = 3;
   */
  pageNumber: number;

  /**
   * Number of events to fetch per page (max=1000)
   *
   * @generated from field: int32 page_limit = 4;
   */
  pageLimit: number;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractHistoryRequest.
 * Use `create(ListContractHistoryRequestSchema)` to create a new message.
 */
export const ListContractHistoryRequestSchema: GenMessage<ListContractHistoryRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 24);

/**
 * ListContractHistoryFilter specifies the filters applied to the returned events
 * Multiple filters can be set and are combined to create a subset
 *
 * @generated from message aurora.core.apiengine.contractsv1.ListContractHistoryFilter
 */
export type ListContractHistoryFilter = Message<"aurora.core.apiengine.contractsv1.ListContractHistoryFilter"> & {
  /**
   * Filter to get a subset of event types
   * All event types are included when not specified
   *
   * @generated from field: repeated aurora.core.consts.contracthistory.ContractHistoryEventType event_types = 1;
   */
  eventTypes: ContractHistoryEventType[];

  /**
   * Timestamp to get all events since the specified time - in RFC3339 with millisecond precision
   *
   * @generated from field: optional string event_time_start = 2;
   */
  eventTimeStart?: string;

  /**
   * Timestamp to get all events before the specified time - in RFC3339 with millisecond precision
   *
   * @generated from field: optional string event_time_end = 3;
   */
  eventTimeEnd?: string;

  /**
   * Filter to get a subset of events only for contracts for the specified instruments (ticker or CUSIP)
   * All instruments are included when not specified
   *
   * @generated from field: repeated string instruments = 4;
   */
  instruments: string[];

  /**
   * Filter to get a subset of events only for contracts with the specified counterparties
   * All counterparties are included when not specified
   *
   * @generated from field: repeated string counterparties = 5;
   */
  counterparties: string[];

  /**
   * Filter to get a subset of events for the specified contracts
   * All contracts are included when not specified
   *
   * @generated from field: repeated string contracts = 6;
   */
  contracts: string[];

  /**
   * Filter to get a subset of events of contracts for which you hold the specified side
   * Both sides are included when not specified
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 7;
   */
  side?: Side;

  /**
   * Filter to get a subset of events which were initiated by a specific type of actor
   * All initiator types are included when not specified
   *
   * @generated from field: optional aurora.core.consts.contracthistory.ContractHistoryEventInitiatorKind initiator_kind = 8;
   */
  initiatorKind?: ContractHistoryEventInitiatorKind;

  /**
   * Filter to get a subset of events which were initiated by a specific actor
   * All initiators are included when not specified
   *
   * @generated from field: optional string initiator_id = 9;
   */
  initiatorId?: string;

  /**
   * Filter to get a subset of events for contracts with the specified open quantity
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter open_quantity = 10;
   */
  openQuantity?: BigintFilter;

  /**
   * Filter to get a subset of events for contracts with the specified contract value
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter contract_value = 11;
   */
  contractValue?: DecimalFilter;

  /**
   * Filter to get a subset of events with the specified open quantity change
   *
   * @generated from field: optional aurora.core.consts.query.BigintFilter open_quantity_change = 12;
   */
  openQuantityChange?: BigintFilter;

  /**
   * Filter to get a subset of events for contracts with the specified settlement types
   * All settlement types are included when not specified
   *
   * @generated from field: repeated aurora.core.consts.settlement.SettlementType settlement_types = 13;
   */
  settlementTypes: SettlementType[];

  /**
   * Filter to get a subset of events for contracts with the specified rate
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter rate = 14;
   */
  rate?: DecimalFilter;

  /**
   * Filter to get a subset of events for contracts with the specified daily interest amount
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter rate_amount = 15;
   */
  rateAmount?: DecimalFilter;

  /**
   * Filter to get a subset of events for contracts with the specified ticker
   *
   * @generated from field: optional string ticker = 16;
   */
  ticker?: string;

  /**
   * Filter to get a subset of events for contracts with the specified unit price
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter unit_price = 17;
   */
  unitPrice?: DecimalFilter;

  /**
   * Filter to get a subset of events with the specified contract value adjustment
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter contract_value_adjustment = 18;
   */
  contractValueAdjustment?: DecimalFilter;

  /**
   * Filter to get a subset of events for contracts with settlement date in the specified range - YYYY-MM-DD format
   *
   * @generated from field: optional string settlement_date_start = 19;
   */
  settlementDateStart?: string;

  /**
   * @generated from field: optional string settlement_date_end = 20;
   */
  settlementDateEnd?: string;

  /**
   * Filter to get a subset of events for contracts with the specified market value
   *
   * @generated from field: optional aurora.core.consts.query.DecimalFilter market_value = 21;
   */
  marketValue?: DecimalFilter;

  /**
   * Filter to get a subset of events for contracts with the specified CUSIP
   *
   * @generated from field: optional string cusip = 22;
   */
  cusip?: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractHistoryFilter.
 * Use `create(ListContractHistoryFilterSchema)` to create a new message.
 */
export const ListContractHistoryFilterSchema: GenMessage<ListContractHistoryFilter> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 25);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractHistorySort
 */
export type ListContractHistorySort = Message<"aurora.core.apiengine.contractsv1.ListContractHistorySort"> & {
  /**
   * Field to sort on
   *
   * @generated from field: aurora.core.consts.contracthistory.ContractHistorySortableField field = 1;
   */
  field: ContractHistorySortableField;

  /**
   * Sorting direction / order
   *
   * @generated from field: aurora.core.consts.query.SortOrder order = 2;
   */
  order: SortOrder;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractHistorySort.
 * Use `create(ListContractHistorySortSchema)` to create a new message.
 */
export const ListContractHistorySortSchema: GenMessage<ListContractHistorySort> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 26);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractHistoryResponse
 */
export type ListContractHistoryResponse = Message<"aurora.core.apiengine.contractsv1.ListContractHistoryResponse"> & {
  /**
   * List of events
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.ContractHistoryEvent events = 1;
   */
  events: ContractHistoryEvent[];

  /**
   * Total number of events
   *
   * @generated from field: int64 total_entries = 2;
   */
  totalEntries: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractHistoryResponse.
 * Use `create(ListContractHistoryResponseSchema)` to create a new message.
 */
export const ListContractHistoryResponseSchema: GenMessage<ListContractHistoryResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 27);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ContractHistoryEvent
 */
export type ContractHistoryEvent = Message<"aurora.core.apiengine.contractsv1.ContractHistoryEvent"> & {
  /**
   * Unique identifier of the event
   *
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * Type of the event
   *
   * @generated from field: aurora.core.consts.contracthistory.ContractHistoryEventType event_type = 2;
   */
  eventType: ContractHistoryEventType;

  /**
   * Event timestamp - in RFC3339 with millisecond precision
   *
   * @generated from field: string event_time = 3;
   */
  eventTime: string;

  /**
   * Event initiator
   *
   * @generated from field: string initiator = 4;
   */
  initiator: string;

  /**
   * Contract state at the time of the event (after the event occurred)
   *
   * @generated from field: aurora.core.apiengine.contractsv1.ContractHistoryState contract_state = 5;
   */
  contractState?: ContractHistoryState;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ContractHistoryEvent.
 * Use `create(ContractHistoryEventSchema)` to create a new message.
 */
export const ContractHistoryEventSchema: GenMessage<ContractHistoryEvent> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 28);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ContractHistoryState
 */
export type ContractHistoryState = Message<"aurora.core.apiengine.contractsv1.ContractHistoryState"> & {
  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * Type of settlement the contract is related to
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 3;
   */
  settlementType: SettlementType;

  /**
   * Instrument the contract is for
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 4;
   */
  instrument?: PbInstrument;

  /**
   * Side (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 5;
   */
  side: Side;

  /**
   * Counterparty ID
   *
   * @generated from field: string counterparty_id = 6;
   */
  counterpartyId: string;

  /**
   * Original total quantity of the contract (that it originally had before any returns)
   *
   * @generated from field: int64 total_quantity = 7;
   */
  totalQuantity: bigint;

  /**
   * Open quantity of the contract at the time of the event
   *
   * @generated from field: int64 open_quantity = 8;
   */
  openQuantity: bigint;

  /**
   * Last prior day market price
   *
   * @generated from field: string unit_price = 9;
   */
  unitPrice: string;

  /**
   * Rate details of the contract at the time of the event
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 10;
   */
  rateDetails?: PbRateDetails;

  /**
   * Value of the contract at the time of the event
   *
   * @generated from field: string contract_value = 11;
   */
  contractValue: string;

  /**
   * Daily interest amount of the contract at the time of the event
   *
   * @generated from field: string interest_due_amount = 12;
   */
  interestDueAmount: string;

  /**
   * Market value of the contract at the time of the event
   *
   * @generated from field: string market_value = 13;
   */
  marketValue: string;

  /**
   * The change in the Market value of the contract as effect of the event
   *
   * @generated from field: string market_value_adjustment = 14;
   */
  marketValueAdjustment: string;

  /**
   * The change in the value of the contract as effect of the event
   *
   * @generated from field: string contract_value_adjustment = 15;
   */
  contractValueAdjustment: string;

  /**
   * The change in the open quantity of the contract as effect of the event
   *
   * @generated from field: int64 open_quantity_change = 16;
   */
  openQuantityChange: bigint;

  /**
   * Settlement Type specific identifier
   * ie. DTCC reference id for SFT
   *
   * @generated from field: string settlement_id = 17;
   */
  settlementId: string;

  /**
   * Settlement date of SFT (if exists)
   *
   * @generated from field: string settlement_date = 19;
   */
  settlementDate: string;

  /**
   * Collateral rate of the contract
   *
   * @generated from field: string collateral_rate = 21;
   */
  collateralRate: string;

  /**
   * Id of the agreement associated with this contract
   *
   * @generated from field: optional string agreement_id = 22;
   */
  agreementId?: string;

  /**
   * Status of the contract
   *
   * @generated from field: aurora.core.consts.ContractStatus status = 23;
   */
  status: ContractStatus;

  /**
   * Rounding Rule for the contract
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 24;
   */
  roundingRule: RoundingRule;

  /**
   * Total quantity currently recalled
   *
   * @generated from field: int64 recalled_quantity = 25;
   */
  recalledQuantity: bigint;

  /**
   * Total quantity that has been returned
   *
   * @generated from field: int64 returned_quantity = 26;
   */
  returnedQuantity: bigint;

  /**
   * Time of contract creation - in RFC3339 with millisecond precision
   *
   * @generated from field: string created_at = 18;
   */
  createdAt: string;

  /**
   * UNDOCUMENTED-PROPERTY
   * deprecated
   * Internal ID
   *
   * @generated from field: string aurora_internal_id = 1;
   */
  auroraInternalId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ContractHistoryState.
 * Use `create(ContractHistoryStateSchema)` to create a new message.
 */
export const ContractHistoryStateSchema: GenMessage<ContractHistoryState> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 29);

/**
 * @generated from message aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnRequest
 */
export type AcceptAwaitingContractReturnRequest = Message<"aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnRequest.
 * Use `create(AcceptAwaitingContractReturnRequestSchema)` to create a new message.
 */
export const AcceptAwaitingContractReturnRequestSchema: GenMessage<AcceptAwaitingContractReturnRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 30);

/**
 * @generated from message aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnResponse
 */
export type AcceptAwaitingContractReturnResponse = Message<"aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnResponse"> & {
  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.AcceptAwaitingContractReturnResponse.
 * Use `create(AcceptAwaitingContractReturnResponseSchema)` to create a new message.
 */
export const AcceptAwaitingContractReturnResponseSchema: GenMessage<AcceptAwaitingContractReturnResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 31);

/**
 * @generated from message aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnRequest
 */
export type RejectAwaitingContractReturnRequest = Message<"aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnRequest.
 * Use `create(RejectAwaitingContractReturnRequestSchema)` to create a new message.
 */
export const RejectAwaitingContractReturnRequestSchema: GenMessage<RejectAwaitingContractReturnRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 32);

/**
 * @generated from message aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnResponse
 */
export type RejectAwaitingContractReturnResponse = Message<"aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnResponse"> & {
  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.RejectAwaitingContractReturnResponse.
 * Use `create(RejectAwaitingContractReturnResponseSchema)` to create a new message.
 */
export const RejectAwaitingContractReturnResponseSchema: GenMessage<RejectAwaitingContractReturnResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 33);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnRequest
 */
export type CancelAwaitingContractReturnRequest = Message<"aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnRequest"> & {
  /**
   * An optional identifier provided by the user to help associate the order request any internal record keeping.
   * If the same value is observed recently then the request will be rejected.
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnRequest.
 * Use `create(CancelAwaitingContractReturnRequestSchema)` to create a new message.
 */
export const CancelAwaitingContractReturnRequestSchema: GenMessage<CancelAwaitingContractReturnRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 34);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnResponse
 */
export type CancelAwaitingContractReturnResponse = Message<"aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnResponse"> & {
  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelAwaitingContractReturnResponse.
 * Use `create(CancelAwaitingContractReturnResponseSchema)` to create a new message.
 */
export const CancelAwaitingContractReturnResponseSchema: GenMessage<CancelAwaitingContractReturnResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 35);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CreateRateModificationRequest
 */
export type CreateRateModificationRequest = Message<"aurora.core.apiengine.contractsv1.CreateRateModificationRequest"> & {
  /**
   * User populated id of this request
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 3;
   */
  rateDetails?: PbRateDetails;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CreateRateModificationRequest.
 * Use `create(CreateRateModificationRequestSchema)` to create a new message.
 */
export const CreateRateModificationRequestSchema: GenMessage<CreateRateModificationRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 36);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CreateRateModificationResponse
 */
export type CreateRateModificationResponse = Message<"aurora.core.apiengine.contractsv1.CreateRateModificationResponse"> & {
  /**
   * Id of rate_modification that was created
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Current status of the rate_modification
   *
   * @generated from field: aurora.core.consts.contractratemodification.ContractRateModificationStatus status = 2;
   */
  status: ContractRateModificationStatus;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 3;
   */
  contractId: string;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 4;
   */
  rateDetails?: PbRateDetails;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CreateRateModificationResponse.
 * Use `create(CreateRateModificationResponseSchema)` to create a new message.
 */
export const CreateRateModificationResponseSchema: GenMessage<CreateRateModificationResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 37);

/**
 * @generated from message aurora.core.apiengine.contractsv1.UpdateRateModificationRequest
 */
export type UpdateRateModificationRequest = Message<"aurora.core.apiengine.contractsv1.UpdateRateModificationRequest"> & {
  /**
   * User populated id of this request
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Id of rate_modification that is to be modified
   *
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.UpdateRateModificationRequest.
 * Use `create(UpdateRateModificationRequestSchema)` to create a new message.
 */
export const UpdateRateModificationRequestSchema: GenMessage<UpdateRateModificationRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 38);

/**
 * @generated from message aurora.core.apiengine.contractsv1.UpdateRateModificationResponse
 */
export type UpdateRateModificationResponse = Message<"aurora.core.apiengine.contractsv1.UpdateRateModificationResponse"> & {
  /**
   * Id of rate_modification that was created
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Current status of the rate_modification
   *
   * @generated from field: aurora.core.consts.contractratemodification.ContractRateModificationStatus status = 2;
   */
  status: ContractRateModificationStatus;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.UpdateRateModificationResponse.
 * Use `create(UpdateRateModificationResponseSchema)` to create a new message.
 */
export const UpdateRateModificationResponseSchema: GenMessage<UpdateRateModificationResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 39);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListRateModificationsRequest
 */
export type ListRateModificationsRequest = Message<"aurora.core.apiengine.contractsv1.ListRateModificationsRequest"> & {
  /**
   * User populated id of this request
   *
   * @generated from field: optional string request_id = 1;
   */
  requestId?: string;

  /**
   * Filter by Id of the rate_modification (assigned by Aurora)
   *
   * @generated from field: optional string id = 2;
   */
  id?: string;

  /**
   * Filter by Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: optional string contract_id = 3;
   */
  contractId?: string;

  /**
   * Filter by Instrument (CUSIP or Ticker)
   *
   * @generated from field: optional string instrument = 4;
   */
  instrument?: string;

  /**
   * Filter by Side (lender or borrower)
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 5;
   */
  side?: Side;

  /**
   * Filter by Counterparty IDs
   *
   * @generated from field: repeated string counterparty_ids = 6;
   */
  counterpartyIds: string[];
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListRateModificationsRequest.
 * Use `create(ListRateModificationsRequestSchema)` to create a new message.
 */
export const ListRateModificationsRequestSchema: GenMessage<ListRateModificationsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 40);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListRateModificationsResponse
 */
export type ListRateModificationsResponse = Message<"aurora.core.apiengine.contractsv1.ListRateModificationsResponse"> & {
  /**
   * Details of the rate_modification(s)
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.RateModificationDetails rate_modifications = 1;
   */
  rateModifications: RateModificationDetails[];

  /**
   * Total number of rate_modifications
   *
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListRateModificationsResponse.
 * Use `create(ListRateModificationsResponseSchema)` to create a new message.
 */
export const ListRateModificationsResponseSchema: GenMessage<ListRateModificationsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 41);

/**
 * @generated from message aurora.core.apiengine.contractsv1.RateModificationDetails
 */
export type RateModificationDetails = Message<"aurora.core.apiengine.contractsv1.RateModificationDetails"> & {
  /**
   * Id of the rate_modification assigned by Aurora
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Current status of the rate_modification
   *
   * @generated from field: aurora.core.consts.contractratemodification.ContractRateModificationStatus status = 3;
   */
  status: ContractRateModificationStatus;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate = 4;
   */
  rate?: PbRateDetails;

  /**
   * Original rate and original benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails original_rate = 5;
   */
  originalRate?: PbRateDetails;

  /**
   * Company ID that initiated this rate modification
   *
   * @generated from field: string initiator_company_id = 6;
   */
  initiatorCompanyId: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.RateModificationDetails.
 * Use `create(RateModificationDetailsSchema)` to create a new message.
 */
export const RateModificationDetailsSchema: GenMessage<RateModificationDetails> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 42);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ContractReturn
 */
export type ContractReturn = Message<"aurora.core.apiengine.contractsv1.ContractReturn"> & {
  /**
   * Return identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Amount of shares being returned
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Status of the return
   *
   * @generated from field: aurora.core.consts.contractreturn.ContractReturnStatus status = 4;
   */
  status: ContractReturnStatus;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ContractReturn.
 * Use `create(ContractReturnSchema)` to create a new message.
 */
export const ContractReturnSchema: GenMessage<ContractReturn> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 43);

/**
 * @generated from message aurora.core.apiengine.contractsv1.BuyIn
 */
export type BuyIn = Message<"aurora.core.apiengine.contractsv1.BuyIn"> & {
  /**
   * Buy-in identifier (persistent identifier inside Aurora system for the return)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Contract identifier (persistent identifier inside Aurora system)
   *
   * @generated from field: string contract_id = 2;
   */
  contractId: string;

  /**
   * Amount of shares being bought-in
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Average price of the shares bought-in
   *
   * @generated from field: string price = 4;
   */
  price: string;

  /**
   * Status of the buy-in
   *
   * @generated from field: aurora.core.consts.contractbuyin.ContractBuyInStatus status = 5;
   */
  status: ContractBuyInStatus;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.BuyIn.
 * Use `create(BuyInSchema)` to create a new message.
 */
export const BuyInSchema: GenMessage<BuyIn> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 44);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CreateContractProposalRequest
 */
export type CreateContractProposalRequest = Message<"aurora.core.apiengine.contractsv1.CreateContractProposalRequest"> & {
  /**
   * User populated id of this request
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Instrument (CUSIP or Ticker)
   *
   * @generated from field: string instrument = 2;
   */
  instrument: string;

  /**
   * Quantity of shares
   *
   * @generated from field: int64 quantity = 3;
   */
  quantity: bigint;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 4;
   */
  rateDetails?: PbRateDetails;

  /**
   * Collateral rate of contract
   *
   * @generated from field: string collateral_rate = 5;
   */
  collateralRate: string;

  /**
   * Rounding Rule for the contract
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 6;
   */
  roundingRule: RoundingRule;

  /**
   * Whether Aurora should instruct delivery for this contract
   *
   * @generated from field: bool instruct_delivery = 7;
   */
  instructDelivery: boolean;

  /**
   * Side (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 9;
   */
  side: Side;

  /**
   * Counterparty ID
   *
   * @generated from field: string counterparty_id = 10;
   */
  counterpartyId: string;

  /**
   * Type of settlement this contract related to
   *
   * @generated from field: optional aurora.core.consts.settlement.SettlementType settlement_type = 11;
   */
  settlementType?: SettlementType;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CreateContractProposalRequest.
 * Use `create(CreateContractProposalRequestSchema)` to create a new message.
 */
export const CreateContractProposalRequestSchema: GenMessage<CreateContractProposalRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 45);

/**
 * @generated from message aurora.core.apiengine.contractsv1.AcceptContractProposalRequest
 */
export type AcceptContractProposalRequest = Message<"aurora.core.apiengine.contractsv1.AcceptContractProposalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: aurora.core.consts.common.Side side = 3;
   */
  side: Side;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.AcceptContractProposalRequest.
 * Use `create(AcceptContractProposalRequestSchema)` to create a new message.
 */
export const AcceptContractProposalRequestSchema: GenMessage<AcceptContractProposalRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 46);

/**
 * @generated from message aurora.core.apiengine.contractsv1.DeclineContractProposalRequest
 */
export type DeclineContractProposalRequest = Message<"aurora.core.apiengine.contractsv1.DeclineContractProposalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: aurora.core.consts.common.Side side = 3;
   */
  side: Side;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.DeclineContractProposalRequest.
 * Use `create(DeclineContractProposalRequestSchema)` to create a new message.
 */
export const DeclineContractProposalRequestSchema: GenMessage<DeclineContractProposalRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 47);

/**
 * @generated from message aurora.core.apiengine.contractsv1.CancelContractProposalRequest
 */
export type CancelContractProposalRequest = Message<"aurora.core.apiengine.contractsv1.CancelContractProposalRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string comment = 2;
   */
  comment?: string;

  /**
   * @generated from field: aurora.core.consts.common.Side side = 3;
   */
  side: Side;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.CancelContractProposalRequest.
 * Use `create(CancelContractProposalRequestSchema)` to create a new message.
 */
export const CancelContractProposalRequestSchema: GenMessage<CancelContractProposalRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 48);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractProposalsRequest
 */
export type ListContractProposalsRequest = Message<"aurora.core.apiengine.contractsv1.ListContractProposalsRequest"> & {
  /**
   * Instrument (CUSIP or Ticker) - optional
   *
   * @generated from field: optional string instrument = 1;
   */
  instrument?: string;

  /**
   * User populated id of a previous request - optional
   *
   * @generated from field: optional string request_id = 2;
   */
  requestId?: string;

  /**
   * Counterparty ID - optional
   *
   * @generated from field: repeated string counterparty_ids = 3;
   */
  counterpartyIds: string[];

  /**
   * Side (lender or borrower) - optional
   *
   * @generated from field: optional aurora.core.consts.common.Side side = 4;
   */
  side?: Side;

  /**
   * Instruct delivery filter — true=delivery instructed, false=pre-established (no delivery). Optional.
   *
   * @generated from field: optional bool instruct_delivery = 5;
   */
  instructDelivery?: boolean;

  /**
   * Status filter - optional
   *
   * @generated from field: repeated aurora.core.consts.contractrequest.ContractRequestStatus status = 6;
   */
  status: ContractRequestStatus[];

  /**
   * Initiator company IDs - optional
   *
   * @generated from field: repeated string initiator_ids = 7;
   */
  initiatorIds: string[];

  /**
   * Created by user email - optional
   *
   * @generated from field: optional string created_by = 8;
   */
  createdBy?: string;

  /**
   * Updated by user email - optional
   *
   * @generated from field: optional string updated_by = 9;
   */
  updatedBy?: string;

  /**
   * ID filter - optional
   *
   * @generated from field: optional string id = 12;
   */
  id?: string;

  /**
   * Page number (1-based)
   *
   * @generated from field: int32 page_number = 10;
   */
  pageNumber: number;

  /**
   * Page limit
   *
   * @generated from field: int32 page_limit = 11;
   */
  pageLimit: number;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractProposalsRequest.
 * Use `create(ListContractProposalsRequestSchema)` to create a new message.
 */
export const ListContractProposalsRequestSchema: GenMessage<ListContractProposalsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 49);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ContractProposal
 */
export type ContractProposal = Message<"aurora.core.apiengine.contractsv1.ContractProposal"> & {
  /**
   * User populated id of the request this response is for
   *
   * @generated from field: string request_id = 1;
   */
  requestId: string;

  /**
   * Side of order (lender or borrower)
   *
   * @generated from field: aurora.core.consts.common.Side side = 2;
   */
  side: Side;

  /**
   * Counterparty ID
   *
   * @generated from field: string counterparty_id = 3;
   */
  counterpartyId: string;

  /**
   * Quantity of shares
   *
   * @generated from field: int64 quantity = 4;
   */
  quantity: bigint;

  /**
   * Rounding rule
   *
   * @generated from field: aurora.core.consts.RoundingRule rounding_rule = 5;
   */
  roundingRule: RoundingRule;

  /**
   * Persistent contract proposal id inside Aurora system
   *
   * @generated from field: string id = 6;
   */
  id: string;

  /**
   * Status of the contract request
   *
   * @generated from field: aurora.core.consts.contractrequest.ContractRequestStatus status = 7;
   */
  status: ContractRequestStatus;

  /**
   * Comment given on Accept, Decline or Cancel that is echoed back
   *
   * @generated from field: optional string comment = 8;
   */
  comment?: string;

  /**
   * Rate and benchmark type for the contract
   *
   * @generated from field: aurora.core.common.protos.PbRateDetails rate_details = 9;
   */
  rateDetails?: PbRateDetails;

  /**
   * Collateral rate of the contract
   *
   * @generated from field: string collateral_rate = 10;
   */
  collateralRate: string;

  /**
   * Instrument
   *
   * @generated from field: aurora.core.common.protos.PbInstrument instrument = 11;
   */
  instrument?: PbInstrument;

  /**
   * Id of contract resulting for this contract request action
   *
   * @generated from field: optional string contract_id = 12;
   */
  contractId?: string;

  /**
   * Human readable Id of contract resulting for this contract request action
   *
   * @generated from field: optional string contract_display_id = 13;
   */
  contractDisplayId?: string;

  /**
   * Whether delivery was instructed (false = pre-established contract)
   *
   * @generated from field: bool instruct_delivery = 14;
   */
  instructDelivery: boolean;

  /**
   * Type of settlement this contract related to
   *
   * @generated from field: aurora.core.consts.settlement.SettlementType settlement_type = 15;
   */
  settlementType: SettlementType;

  /**
   * Initiator company display ID
   *
   * @generated from field: string initiator_company_id = 16;
   */
  initiatorCompanyId: string;

  /**
   * Created at timestamp
   *
   * @generated from field: string created_at = 17;
   */
  createdAt: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: string updated_at = 18;
   */
  updatedAt: string;

  /**
   * Created by user (email or CONTRA)
   *
   * @generated from field: string created_by = 19;
   */
  createdBy: string;

  /**
   * Updated by user (email or CONTRA)
   *
   * @generated from field: string updated_by = 20;
   */
  updatedBy: string;
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ContractProposal.
 * Use `create(ContractProposalSchema)` to create a new message.
 */
export const ContractProposalSchema: GenMessage<ContractProposal> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 50);

/**
 * @generated from message aurora.core.apiengine.contractsv1.ListContractProposalsResponse
 */
export type ListContractProposalsResponse = Message<"aurora.core.apiengine.contractsv1.ListContractProposalsResponse"> & {
  /**
   * Total number of contracts in the response
   *
   * @generated from field: optional int64 number_of_contracts = 1;
   */
  numberOfContracts?: bigint;

  /**
   * Details of the contract proposals
   *
   * @generated from field: repeated aurora.core.apiengine.contractsv1.ContractProposal contract_proposals = 2;
   */
  contractProposals: ContractProposal[];
};

/**
 * Describes the message aurora.core.apiengine.contractsv1.ListContractProposalsResponse.
 * Use `create(ListContractProposalsResponseSchema)` to create a new message.
 */
export const ListContractProposalsResponseSchema: GenMessage<ListContractProposalsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_contracts_contracts, 51);

/**
 * @generated from enum aurora.core.apiengine.contractsv1.ListContractsStatusFilter
 */
export enum ListContractsStatusFilter {
  /**
   * @generated from enum value: OPEN = 0;
   */
  OPEN = 0,

  /**
   * @generated from enum value: CLOSED = 1;
   */
  CLOSED = 1,
}

/**
 * Describes the enum aurora.core.apiengine.contractsv1.ListContractsStatusFilter.
 */
export const ListContractsStatusFilterSchema: GenEnum<ListContractsStatusFilter> = /*@__PURE__*/
  enumDesc(file_modules_apiengine_services_contracts_contracts, 0);

/**
 * Methods to change the status of currently active contracts
 *
 * The caller must be either on the lending- or borrowing side of the contract.
 *
 * @generated from service aurora.core.apiengine.contractsv1.ContractService
 */
export const ContractService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.GetContract
   */
  getContract: {
    methodKind: "unary";
    input: typeof GetContractRequestSchema;
    output: typeof GetContractResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ListContracts
   */
  listContracts: {
    methodKind: "unary";
    input: typeof ListContractsRequestSchema;
    output: typeof ListContractsResponseSchema;
  },
  /**
   * CancelContract can be use to cancel a Pending Contract
   *
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelContract
   */
  cancelContract: {
    methodKind: "unary";
    input: typeof CancelContractRequestSchema;
    output: typeof CancelContractResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.RecallContract
   */
  recallContract: {
    methodKind: "unary";
    input: typeof RecallContractRequestSchema;
    output: typeof RecallContractResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelRecallContract
   */
  cancelRecallContract: {
    methodKind: "unary";
    input: typeof CancelRecallContractRequestSchema;
    output: typeof CancelRecallContractResponseSchema;
  },
  /**
   * ### Buying-In Against Recalled Contracts
   * Where a lender has requested a recall of a contract, but the borrower has not returned the shares before the
   * `allowed_execution_date` indicated on the Contract Recall, the lender may buy-in the shares against the borrower.
   *
   * Aurora acts as a gateway to capture the purchase price and quantity of this buy-in, allowing the lender to reclaim
   * the costs of the buy-in against the borrower, and adjusting the contract records within Aurora and downstream clearing and settlement.
   * The lender may submit the execution price and quantity of shares by submitting this message.
   *
   * **Note that buy-ins are allocated against outstanding recalls for the indicated contract on a first-in-first-out basis,
   * and therefore a `contract_recall_id` is not supported in this message.**
   *
   * The submitted buy-in details must be processed by DTC before updating outstanding contracts and recall request(s)
   * within Aurora.
   *
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.BuyInContract
   */
  buyInContract: {
    methodKind: "unary";
    input: typeof BuyInContractRequestSchema;
    output: typeof BuyInContractResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ListRecalls
   */
  listRecalls: {
    methodKind: "unary";
    input: typeof ListRecallsRequestSchema;
    output: typeof ListRecallsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelAllRecalls
   */
  cancelAllRecalls: {
    methodKind: "unary";
    input: typeof CancelAllRecallsRequestSchema;
    output: typeof CancelAllRecallsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ReturnContract
   */
  returnContract: {
    methodKind: "unary";
    input: typeof ReturnContractRequestSchema;
    output: typeof ReturnContractResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelAllPendingReturns
   */
  cancelAllPendingReturns: {
    methodKind: "unary";
    input: typeof CancelAllPendingReturnsRequestSchema;
    output: typeof CancelAllPendingReturnsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelSinglePendingReturn
   */
  cancelSinglePendingReturn: {
    methodKind: "unary";
    input: typeof CancelSinglePendingReturnRequestSchema;
    output: typeof CancelSinglePendingReturnResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.AcceptAwaitingContractReturn
   */
  acceptAwaitingContractReturn: {
    methodKind: "unary";
    input: typeof AcceptAwaitingContractReturnRequestSchema;
    output: typeof AcceptAwaitingContractReturnResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.RejectAwaitingContractReturn
   */
  rejectAwaitingContractReturn: {
    methodKind: "unary";
    input: typeof RejectAwaitingContractReturnRequestSchema;
    output: typeof RejectAwaitingContractReturnResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelAwaitingContractReturn
   */
  cancelAwaitingContractReturn: {
    methodKind: "unary";
    input: typeof CancelAwaitingContractReturnRequestSchema;
    output: typeof CancelAwaitingContractReturnResponseSchema;
  },
  /**
   * ListContractHistory provides a way to query contract events
   * This can be used to get the full history of everything that has happened to a contract
   * or for example to get all the returns that happened on a specific date or for a specific instrument
   *
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ListContractHistory
   */
  listContractHistory: {
    methodKind: "unary";
    input: typeof ListContractHistoryRequestSchema;
    output: typeof ListContractHistoryResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CreateRateModification
   */
  createRateModification: {
    methodKind: "unary";
    input: typeof CreateRateModificationRequestSchema;
    output: typeof CreateRateModificationResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelRateModification
   */
  cancelRateModification: {
    methodKind: "unary";
    input: typeof UpdateRateModificationRequestSchema;
    output: typeof UpdateRateModificationResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.AcceptRateModification
   */
  acceptRateModification: {
    methodKind: "unary";
    input: typeof UpdateRateModificationRequestSchema;
    output: typeof UpdateRateModificationResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.RejectRateModification
   */
  rejectRateModification: {
    methodKind: "unary";
    input: typeof UpdateRateModificationRequestSchema;
    output: typeof UpdateRateModificationResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ListRateModifications
   */
  listRateModifications: {
    methodKind: "unary";
    input: typeof ListRateModificationsRequestSchema;
    output: typeof ListRateModificationsResponseSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CreateContractProposal
   */
  createContractProposal: {
    methodKind: "unary";
    input: typeof CreateContractProposalRequestSchema;
    output: typeof ContractProposalSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.AcceptContractProposal
   */
  acceptContractProposal: {
    methodKind: "unary";
    input: typeof AcceptContractProposalRequestSchema;
    output: typeof ContractProposalSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.DeclineContractProposal
   */
  declineContractProposal: {
    methodKind: "unary";
    input: typeof DeclineContractProposalRequestSchema;
    output: typeof ContractProposalSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.CancelContractProposal
   */
  cancelContractProposal: {
    methodKind: "unary";
    input: typeof CancelContractProposalRequestSchema;
    output: typeof ContractProposalSchema;
  },
  /**
   * @generated from rpc aurora.core.apiengine.contractsv1.ContractService.ListContractProposals
   */
  listContractProposals: {
    methodKind: "unary";
    input: typeof ListContractProposalsRequestSchema;
    output: typeof ListContractProposalsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_contracts_contracts, 0);

